import './team-nav.styles.scss';
import { NavLink } from 'react-router-dom';

const PAGES = [
    { to: 'roster', label: 'Roster' },
    { to: 'lineup', label: 'Lineup' },
    { to: 'strategy', label: 'Strategy' },
];

// Links between the manager's Roster, Lineup and Strategy pages, at the top
// of each. base: the league's manager path (/home/:leagueId).
const TeamNav = ({ base }) => (
    <nav className='team-nav chips' aria-label='Team pages'>
        {PAGES.map(p => (
            <NavLink key={p.to} to={`${base}/${p.to}`} className={({ isActive }) => `chip ${isActive ? 'active' : ''}`}>
                {p.label}
            </NavLink>
        ))}
    </nav>
)

export default TeamNav
